import styled from "@emotion/styled";

export interface FlexDivProps {
  display?: "flex" | "inline-flex";
  flexDirection?: "row" | "column";
  alignItems?: "center" | "left" | "flex-start" | "flex-end";
  justifyContent?: "space-between" | "start" | "end" | "center";
  margin?: string;
  padding?: string;
  width?: string;
  height?: string;
  gap?: string;
  grow?: boolean;
  wrap?: boolean;
  noWrap?: boolean;
}
export const FlexDiv = styled.div<FlexDivProps>`
  display: ${(props) => props.display || "flex"};
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : "row"};
  align-items: ${(props) => (props.alignItems ? props.alignItems : "left")};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : "start"};
  margin: ${(props) => (props.margin ? props.margin : 0)};
  ${(props) => (props.padding ? `padding: ${props.padding}` : "")};
  ${(props) => (props.width ? `width: ${props.width}` : "")};
  ${(props) => (props.height ? `height: ${props.height}` : "")};
  ${(props) => (props.gap ? `gap: ${props.gap}` : "")};
  ${(props) => (props.grow ? `flex-grow: 1` : "")};
  ${(props) => (props.wrap ? `flex-wrap: wrap` : "")};
  ${(props) => (props.noWrap ? `flex-wrap: nowrap` : "")};
`;
